import {CommonService} from '../../services/common.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {AccessoriesFormComponent} from './accessories-form/accessories-form.component';
import {ToastMessagesService} from '../../services/toast-messages.service';
import {MatSort} from '@angular/material/sort';
import {ExportCsvService} from '../../services/export-csv.service';

@Component({
  selector: 'app-material-accessories',
  styleUrls: ['./material-accessories.component.scss'],
  templateUrl: './material-accessories.component.html'
})
export class MaterialCodesAccessoriesComponent implements OnInit {
  @ViewChild(MatSort, {static: false}) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  materialAccessories: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayPartColumns = ['id', 'material_id', 'material_description', 'manufacturer_description',
    'accessory_category_description', 'value', 'is_active', 'actions'];
  loading: boolean;
  data: any[];
  private sort: MatSort;

  constructor(private commonService: CommonService,
              private matDialog: MatDialog,
              private exportCsvService: ExportCsvService,
              private toastMessagesService: ToastMessagesService) {
    this.loading = false;
  }

  public async ngOnInit(): Promise<any> {
    await this.initMaterialAccessories();
  }

  async initMaterialAccessories() {
    try {
      this.loading = true;
      this.data = await this.commonService.getSimpleList('accessory/material') as any[];
      this.materialAccessories = new MatTableDataSource<any>(this.data);
    } catch (e) {
      throw e;
    } finally {
      this.loading = false;
    }
  }

  applyFilter(filterValue: string) {
    this.materialAccessories.filter = filterValue.trim().toLowerCase();
  }

  exportExcel() {
    const {data, columns} = this.formatExcelModel();
    this.exportCsvService.exportAsCustomExcelFile(data, 'MaterialAccessories', columns);
  }

  formatExcelModel() {
    const data = [];
    for (const record of this.materialAccessories.data) {
      const model = {
        material_id: record.material_id,
        material_description: record.material_description,
        manufacturer_description: record.manufacturer_description,
        accessory_category_description: record.accessory_category_description,
        value: record.value,
        is_active_name: record.is_active ? 'Ενεργό' : 'Ανενεργό',
      };
      data.push(model);
    }

    const columns = [{
      key: 'material_id',
      label: 'Κωδικός Είδους',
    },
    {
      key: 'material_description',
      label: 'Περιγραφή Είδους',
    },
    {
      key: 'manufacturer_description',
      label: 'Κατασκευαστής',
    },
      {
      key: 'accessory_category_description',
      label: 'Κωδικός Θήκης',
    },
    {
      key: 'value',
      label: 'Ποσότητα',
    },
    {
      key: 'is_active_name',
      label: 'Κατάσταση',
    }
    ];

    return {data, columns};
  }

  getTooltipText(isActive: number) {
    return isActive ? 'Ενεργό' : 'Ανενεργό';
  }

  getIconColor(isActive: number) {
    return isActive ? '#4caf50' : '#dd0330';
  }

  setDataSourceAttributes() {
    this.materialAccessories.sort = this.sort;
  }

  showAccessoriesDialog(material?) {
    const mode = material ? 'edit' : 'add';
    const dialog = this.matDialog.open(AccessoriesFormComponent, {
      width: '450',
      data: {
        material,
        mode
      }
    });

    dialog.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          if (mode === 'edit') {
            await this.commonService.updateObject('accessory/material', result);
          } else {
            await this.commonService.insertObject('accessory/material', result);
          }

          this.toastMessagesService.toastUpdateSuccess();
          await this.initMaterialAccessories();
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }

}
